<template>
  <section class="flex w-full flex-col gap-6 p-6">
    <h1 class="text-4xl font-bold text-gray-300">Testing page</h1>
    <div class="grid w-full grid-cols-4 gap-4">
      <MarketplaceCardPortfolioNewComponent :product="data" :strategy="data.strategies[0]" />
      <MarketplaceCardComponent :product="data" :strategy="data.strategies[0]" />
    </div>
  </section>
</template>

<script>
import EventBus from "../../../shared/utils/event_bus";
import MarketplaceCardPortfolioNewComponent from "../../marketplace/components/products/card/marketplace-card-portfolio-new.component.vue";
import MarketplaceCardComponent from "../../marketplace/components/products/card/marketplace-card.component.vue";
export default {
  components: {
    MarketplaceCardPortfolioNewComponent,
    MarketplaceCardComponent,
  },

  data() {
    return {
      input: "",
      response: "",
      data: {
        product_id: 83,
        product_name: "AgileBox",
        product_type: "PORTFOLIO",
        product_listed: "EXTENSION",
        extension_id: 41,
        partner_name: "AgileBot",
        partner_badge: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/agileinvest_light_badge.svg",
        extension_group: "AGL_EXT_1",
        strategies: [
          {
            strategy_id: 100,
            strategy_name: "AgileBox",
            strategy_symbol: "WINFUT",
            strategy_risk: "ALTO",
            strategy_style: "DAY_TRADE",
            strategy_is_premium: true,
            min_volume: 1,
            min_capital: 5000,
            tr_perc_return: 690.44,
            max_loss: 150,
            marketplace_status: "EXTENSION",
          },
        ],
      },
    };
  },
  methods: {
    test() {
      this.worker.sendMessage({
        type: "TEST",
        data: this.input,
      });
    },
  },
  created() {
    EventBus.$on("MARKET_DATA", (e) => {
      // console.log("component got", e);
      // this.response = JSON.stringify(e);
    });
  },
};
</script>

<style></style>
